import React from 'react'
import styled from 'styled-components'
import Colors from '../../assets/styles/Colors'
import FemaleIcon from '../../assets/v2/JSX/FemaleIcon'
import MaleIcon from '../../assets/v2/JSX/MaleIcon'
import Responsive from '../../assets/config/Responsive'
import GenderFemaleIcon from '../../assets/v2/JSX/GenderFemaleIcon'
import GenderMaleIcon from '../../assets/v2/JSX/GenderMaleIcon'
//
//
const GenderCard: React.FC<{
  selected: boolean
  gender: 'male' | 'female' | string
  maleText?: string
  femaleText?: string
  disabled?: boolean
  style?: React.CSSProperties
  pet?: boolean
  error?: boolean
  errorText?: string
  onClick?: (value: 'male' | 'female') => void
  onBlur?: (value: any) => void
}> = ({
  selected = false,
  gender,
  maleText,
  femaleText,
  disabled = false,
  style,
  pet = false,
  error = false,
  errorText,
  onClick,
  onBlur,
}) => {
  return (
    <Wrapper
      $error={error}
      onBlur={onBlur}
      $selected={selected ?? false}
      $disabled={disabled ?? false}
      style={style}
      onClick={() => {
        if (gender && gender === 'male' && onClick) {
          onClick('male')
        }
        //
        if (gender && gender === 'female' && onClick) {
          onClick('female')
        }
      }}
    >
      {/* male */}
      {gender === 'male' ? (
        <>
          {pet && <GenderMaleIcon />}
          {!pet && <MaleIcon />}

          <span>{maleText}</span>
        </>
      ) : null}

      {/* female */}
      {gender === 'female' ? (
        <>
          {pet && <GenderFemaleIcon />}
          {!pet && <FemaleIcon />}

          <span>{femaleText}</span>
        </>
      ) : null}

      <CircleStatus $selected={selected ?? false} />
    </Wrapper>
  )
}
//

const Wrapper = styled.div<{ $selected: boolean; $disabled: boolean; $error: boolean }>`
  /* disabled styles */
  user-select: ${({ $disabled }) => ($disabled ? `none` : `unset`)};
  pointer-events: ${({ $disabled }) => ($disabled ? `none` : `unset`)};
  opacity: ${({ $disabled }) => ($disabled ? `0.7` : `unset`)};
  background-color: ${({ $disabled }) => ($disabled ? Colors.secondaryGrey : Colors.white)};
  border: 1px solid
    ${({ $error, $selected, $disabled }) =>
      $disabled ? Colors.secondaryGrey : $error ? Colors.primaryRed : $selected ? Colors.primaryBlack : Colors.Alto};

  cursor: ${({ $disabled }) => ($disabled ? `not-allowed` : `pointer`)};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 112px;
  width: 100%;
  border-radius: 4px;

  /* svg icons */
  svg {
    width: 48px;
    height: 40px;
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  }

  /* span text */
  span {
    font-size: 14px;
    text-transform: capitalize;
    color: ${({ $disabled }) => ($disabled ? Colors.nevadaGrey : Colors.primaryBlack)};
    margin-top: 12px;
  }

  /* responsive */
  ${Responsive.mobile} {
    height: 96px;

    svg {
      transform: scale(0.8);
    }

    span {
      margin-top: 10px;
    }
  }
`

const CircleStatus = styled.div<{ $selected: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  top: 9px;
  right: 9px;
  border: ${({ $selected }) => ($selected ? 'unset' : `solid 1px ${Colors.nevadaGrey}`)};
  box-shadow: ${({ $selected }) => ($selected ? `inset 0px 0px 0px 9px ${Colors.primaryRed}` : 'unset')};

  /*  */
  ${Responsive.mobile} {
    width: 20px;
    height: 20px;
    box-shadow: ${({ $selected }) => ($selected ? `inset 0px 0px 0px 7px ${Colors.primaryRed}` : 'unset')};
  }
`
//
export default GenderCard
